/**
 * Single source of truth for the backend API base URL.
 *
 * CRA bakes REACT_APP_* at BUILD time, so each deployment must set
 * REACT_APP_API_BASE_URL to the backend it should talk to:
 *   - production build  → https://api-copilotprinter.up.railway.app
 *   - staging build     → https://copilotprinter-api-staging.up.railway.app
 *   - local dev         → unset (falls back to http://localhost:3003)
 *
 * The production URL is the fallback ONLY when REACT_APP_API_BASE_URL is unset
 * AND NODE_ENV === 'production' (i.e. a misconfigured prod build still works).
 * A STAGING build that forgets to set REACT_APP_API_BASE_URL would otherwise
 * silently read/write PRODUCTION — so staging deploys MUST set it explicitly
 * (see deployment/STAGING_ISOLATION.md). Centralizing here replaces the six
 * copies of this logic that had drifted across the codebase.
 */
const PRODUCTION_API_URL = 'https://api-copilotprinter.up.railway.app';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'production' ? PRODUCTION_API_URL : 'http://localhost:3003');

/**
 * Base domain seller storefront subdomains live under ({sub}.{base}).
 * Staging serves storefronts from *.staging.craftflow.store (own Vercel
 * project + staging API/DB), so the staging admin build must render staging
 * URLs. Explicit REACT_APP_STOREFRONT_BASE_DOMAIN wins; otherwise inferred
 * from the (mandatory on staging) API base URL.
 */
export const STOREFRONT_BASE_DOMAIN =
  process.env.REACT_APP_STOREFRONT_BASE_DOMAIN ||
  (API_BASE_URL.includes('-staging') ? 'staging.craftflow.store' : 'craftflow.store');

export default API_BASE_URL;
